import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  const statCards = [
    {
      label: '예정된 세션',
      value: stats?.upcomingSessions,
      icon: 'Calendar',
      color: 'primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: '총 참가자',
      value: stats?.totalParticipants,
      icon: 'Users',
      color: 'success',
      bgColor: 'bg-success/10'
    },
    {
      label: '진행 중인 등록',
      value: stats?.activeRegistrations,
      icon: 'Clock',
      color: 'warning',
      bgColor: 'bg-warning/10'
    },
    {
      label: '완료된 세션',
      value: stats?.completedSessions,
      icon: 'CheckCircle',
      color: 'secondary',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-4 md:gap-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-xl p-3 sm:p-4 md:p-6 hover-lift transition-athletic"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <p className="text-[10px] sm:text-sm caption text-muted-foreground mb-1 sm:mb-2 leading-tight">
                {stat?.label}
              </p>
              <p className="text-lg sm:text-2xl md:text-3xl font-heading font-bold text-foreground data-text leading-none">
                {stat?.value?.toLocaleString('ko-KR')}
              </p>
            </div>
            
            <div className={`w-9 h-9 sm:w-12 sm:h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center flex-shrink-0`}>
              <Icon 
                name={stat?.icon} 
                size={20} 
                color={`var(--color-${stat?.color})`}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;